module.exports = "https://la-static.vkplay.ru/promo/thefirst/img/logo-part-1.0fe19993.png";